module.exports = __webpack_public_path__ + "img/dashed_arrow.8b020811.svg";